export default __webpack_public_path__ + "static/media/instagram.218cab63.svg";